import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import { isSSOPending, clearSSOPending } from '@/utils/login'

const Login = () => import('@/views/Login.vue')
const ShellLayout = () => import('@/layouts/index.vue')
const CloudWatchLogs = () => import('@/views/CloudWatchLogs.vue')

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    component: ShellLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: CloudWatchLogs
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  // Login page ('/') handles two cases:
  //   1) SSO round-trip just came back from the IdP -> probe backend and
  //      forward to /home on success (clearing the SSO-pending flag).
  //   2) User opened the SPA fresh but the cached auth state is still
  //      valid (within the CloudIDP 30min token window) -> skip the
  //      login screen and go straight to /home, no SSO redirect.
  if (to.path === '/') {
    if (isSSOPending()) {
      const authed = await store.dispatch('RefreshPrincipal')
      clearSSOPending()
      if (authed) {
        next({ name: 'home', replace: true })
        return
      }
      next()
      return
    }
    // No SSO in progress: trust the localStorage cache via GetPrincipal.
    const authed = await store.dispatch('GetPrincipal')
    if (authed) {
      next({ name: 'home', replace: true })
      return
    }
    next()
    return
  }

  // All other routes require authentication
  const authed = await store.dispatch('GetPrincipal')
  if (authed) {
    next()
  } else {
    next({ name: 'login' })
  }
})

export default router

